import { campsSliderTnsInit } from 'new_design/desktop/common/sliders';
import $ from "jquery";

$(document).ready(function() {
  campsSliderTnsInit();
})
